module.exports = __webpack_public_path__ + "static/img/how_to_repay_cover.4d9b4257.png";